'use strict';

class AccountDownload {
  constructor($window, originatorService, Notification) {
    this.$window = $window;
    this.originatorService = originatorService;
    this.Notification = Notification;
  }

  $onInit() {
    this.codes = [{
      value: 'json',
      label: 'JSON'
    }, {
      value: 'xml',
      label: 'XML'
    }];
    this.data = {
      code: 'json'
    };
  }

  download() {
    this.originatorService.validateDownload()
      .then(() => {
        this.originatorService.downloadAllData(this.data.code, this.data.includeAudit)
          .then(() => {
          });
      });
  }
}

AccountDownload.$inject = ['$window', 'originatorService', 'Notification'];

const accountDownload = {
  controller: AccountDownload,
  template: `
    <h2>Last ned mine data</h2>
    <h3>Dataene kommer i form av en fil i JSON- eller XML-format</h3>

    <fieldset>
      <div>
        <label for="code">Velg format:</label>
        <select ng-model="$ctrl.data.code" ng-options="code.value as code.label for code in $ctrl.codes" id="code" required></select>
      </div>

      <div>
        <label for="includeAudit" data-balloon="En detaljert liste av dine aktiviteter i SendRegning; kan være store datamengder">
          <input type="checkbox" id="includeAudit" name="includeAudit" ng-model="$ctrl.data.includeAudit"> Inkluder aktivitetslogg
          <i class="fa fa-question-circle"></i>
          </label>
      </div>
    </fieldset>
    
    <a role="button" class="button secondary" href="#/konto">Avbryt</a>
    <button ng-click="$ctrl.download()" class="button alert">Last ned</button>
  `
};

angular
  .module('SendRegning')
  .component('accountDownload', accountDownload)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/last-ned', {
        title: 'Last ned data',
        template: '<account-download />',
        secure: true
      });
  });
